const SIZES = {
  sm: { mark: "h-6 w-6 rounded-md text-[11px]", word: "text-base" },
  md: { mark: "h-7 w-7 rounded-lg text-xs", word: "text-lg" },
  lg: { mark: "h-10 w-10 rounded-xl text-lg", word: "text-2xl" },
};

export const BrandMark = ({ size = "md", className = "" }) => (
  <span
    className={`inline-flex items-center justify-center font-display font-extrabold text-white leading-none bg-gradient-to-br from-[#1d4ed8] via-[#2563eb] to-[#06b6d4] shadow-lg shadow-blue-500/25 ${SIZES[size].mark} ${className}`}
    data-testid="brand-mark"
  >
    M
  </span>
);

export default function BrandLogo({ size = "md", withMark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      {withMark && <BrandMark size={size} />}
      <span className={`font-display font-extrabold tracking-tight text-gradient ${SIZES[size].word}`}>MILTROO</span>
    </span>
  );
}
